export const selectInventoryRequest = state => state.inventory.request
export const selectInventoryRequests = state => state.inventory.requests
export const selectTotalInventoryRequests = state => state.inventory.totalRequests
export const selectInventoryRequestResponse = state => state.inventory.requestCreate
export const selectInventoryReport = state => state.inventory.report || []
export const selectInventoryReportItems = state => state.inventory.items
export const selectInventoryReportRequest = state => state.inventory.inventoryReport
